/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetVersionHistoryQueryResponse, FilesControllerGetVersionHistoryPathParams, FilesControllerGetVersionHistory401, FilesControllerGetVersionHistory403 } from "../../models/filesController/FilesControllerGetVersionHistory";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerGetVersionHistory } from "../../clients/filesService/filesControllerGetVersionHistory";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerGetVersionHistoryQueryKey = (id: FilesControllerGetVersionHistoryPathParams["id"]) => [{
  url: '/api/v1/files/:id/versions',
  params: {
    id: id
  }
}] as const;
export type FilesControllerGetVersionHistoryQueryKey = ReturnType<typeof filesControllerGetVersionHistoryQueryKey>;
export function filesControllerGetVersionHistoryQueryOptions(id: FilesControllerGetVersionHistoryPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerGetVersionHistoryQueryKey(id);
  return queryOptions<FilesControllerGetVersionHistoryQueryResponse, ResponseErrorConfig<FilesControllerGetVersionHistory401 | FilesControllerGetVersionHistory403>, FilesControllerGetVersionHistoryQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerGetVersionHistory(id, config);
    }
  });
}

/**
 * @summary Get version history for a file
 * {@link /api/v1/files/:id/versions}
 */
export function useFilesControllerGetVersionHistory<TData = FilesControllerGetVersionHistoryQueryResponse, TQueryData = FilesControllerGetVersionHistoryQueryResponse, TQueryKey extends QueryKey = FilesControllerGetVersionHistoryQueryKey>(id: FilesControllerGetVersionHistoryPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<FilesControllerGetVersionHistoryQueryResponse, ResponseErrorConfig<FilesControllerGetVersionHistory401 | FilesControllerGetVersionHistory403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerGetVersionHistoryQueryKey(id);
  const query = useQuery({
    ...filesControllerGetVersionHistoryQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FilesControllerGetVersionHistory401 | FilesControllerGetVersionHistory403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}